const translations = {
    batteryPacks: 'Battery Packs',
    cyclesUnit: 'cycles',
    firmware: 'Firmware',
    flightsUnit: 'flights',
    flowMeter: 'Flow Meter',
    flowMeterLabel: 'Flow meter',
    hoursUnit: 'h',
    motorLabel: 'Motor',
    motors: 'Motors',
    noInterval: 'No service interval set',
    propellerLabel: 'Propeller',
    propellers: 'Propellers',
    pumpLabel: 'Pump',
    pumps: 'Pumps',
    radars: 'Radars',
    wearDetail: '{{percent}}% · {{remaining}} {{unit}} to service'
};

export default translations;
